import React, { useState } from 'react';
import { UserInfo } from '@/components/custom/user';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, AvatarFallback, AvatarStack, AvatarWrapper } from '@/components/ui/avatar';
import { Sheet, SheetBody, SheetContent, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Card, CardContent } from '@/components/ui/card';

export default function GroupModal(props) {
  const { t } = useTranslation();
  const { data, truncateIn, i, size = 'sm' } = props;
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  function avatarImageMemorized(avatar) {
    const avatarImage = avatar?.image?.url;
    return avatarImage;
  }

  useEffect(() => {
    let newUsers = data;
    if (searchTerm !== '') {
      newUsers = newUsers.filter(a => a.name != null && a.name.toLowerCase().includes(searchTerm.toLocaleLowerCase()));
    }
    setFilteredUsers(newUsers);
  }, [searchTerm, data]);

  return (
    data && (
      <>
        <AvatarStack
          size={size}
          onClick={() => setShowModal(true)}
          {...props}
        >
          {data.length <= (truncateIn || 3) &&
            data.map(avatar => (
              <AvatarWrapper
                key={avatar?.id}
                size={size}
                isHoverable
                src={avatarImageMemorized(avatar)}
                text={avatar?.name}
                className="cursor-pointer"
              />
            ))}

          {data?.length > (truncateIn || 3) && (
            <>
              {data?.slice(0, truncateIn || 3).map(avatar => (
                <AvatarWrapper
                  key={avatar?.id}
                  size={size}
                  isHoverable
                  src={avatarImageMemorized(avatar)}
                  text={avatar?.name}
                  className="cursor-pointer"
                />
              ))}
              <Avatar
                size={size}
                isHoverable
                title={data?.slice(truncateIn || 3).map(avatar => ` ${avatar?.name}`)}
              >
                <AvatarFallback className="cursor-pointer font-bold text-primary">+{data?.length - (truncateIn || 3)}</AvatarFallback>
              </Avatar>
            </>
          )}
        </AvatarStack>

        <Sheet
          open={showModal}
          onOpenChange={setShowModal}
        >
          <SheetContent>
            <SheetHeader>
              <SheetTitle>
                {t('projects.sidebarGroup')} {i + 1}
              </SheetTitle>
              <h3 className="modal__simple-title modal__simple-title--with-btn">
                {t('projects.sidebarGroup')} {i + 1}
              </h3>
              <span className="box-widget__text">
                {data.length} <span>{t('sideBar.participants')}</span>
              </span>
            </SheetHeader>

            <SheetBody>
              <div className="form__row">
                <label
                  htmlFor="participantsSearch"
                  className="form__label"
                >
                  {t('textsCommon.research')}
                </label>
                <input
                  aria-label="Buscar estudante"
                  className="form__control form__control--search-with-icon"
                  style={{ width: 'auto' }}
                  placeholder={t('projects.placeholderStudentName')}
                  type="search"
                  name="studentsSearch"
                  id="studentsSearch"
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>

              <div className="flex h-0 grow flex-col gap-4 overflow-y-auto">
                {filteredUsers?.map(user => (
                  <Card
                    key={user?.id}
                    isHover
                  >
                    <CardContent>
                      <UserInfo user={user} />
                    </CardContent>
                  </Card>
                ))}
              </div>
            </SheetBody>

            <SheetFooter />
          </SheetContent>
        </Sheet>
      </>
    )
  );
}
